import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
} from '@mui/material';


const ReviewTheSalesOrder = (props) => {
  const { handleBack, products, data, handleSubmit, t } = props;


  const [filteredProducts, setFilteredProducts] = useState([]);

  useEffect(() => {
    // Extract selected product IDs from currentStep1
    const selectedProductSet = new Set(data.currentStep1);

    // Filter products based on selected IDs
    const filtered = products.filter((product) =>
      selectedProductSet.has(product.id)
    );

    setFilteredProducts(filtered);
  }, [products, data.currentStep1]);

  // Destructure quantities from currentStep2
  const { quantities, portings } = data.currentStep2;

  // Group products by product_family and calculate subtotal based on quantity
  const groupedProducts = filteredProducts.reduce((acc, product) => {
    const family = product.product_family;

    // Get quantity for the current product; default to 1 if not specified
    const quantity = quantities[product.id] || 1;

    // Calculate subtotal for the current product
    const productSubtotal = product.list_price * quantity;

    if (!acc[family]) {
      acc[family] = 0;
    }

    acc[family] += productSubtotal;

    return acc;
  }, {});

  // Convert the grouped object to a sorted array
  const sortedGroupedProducts = Object.keys(groupedProducts)
    .sort()
    .map((family) => ({
      productFamily: family,
      subtotal: groupedProducts[family],
    }));

  // Calculate totals
  const untaxedAmount = sortedGroupedProducts.reduce(
    (sum, family) => sum + family.subtotal,
    0
  );
  const taxes = untaxedAmount * 0.1; // Assuming a 10% tax rate
  const total = untaxedAmount + taxes;


  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h5" sx={{ mb: 3 }}>
        {('ReviewSalesOrder')}
      </Typography>

      <TableContainer component={Paper}>
            <Table>
              <TableHead sx={{ bgcolor: '#4BABCC' }}>
                <TableRow>
                  <TableCell>
                    <Typography color={'white'} fontWeight="bold">
                    {t('Product')}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography color={'white'} fontWeight="bold">
                    {t('ProductFamily')}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography color={'white'} fontWeight="bold">
                    {t('Description')}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography color={'white'} fontWeight="bold">
                    {t('OrderedQty')}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography color={'white'} fontWeight="bold">
                    {t('UnitPrice')}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography color={'white'} fontWeight="bold">
                    {t('Porting')}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography color={'white'} fontWeight="bold">
                    {t('Subtotal')}
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredProducts.map((product) => (
                  <TableRow key={product.id}>
                    <TableCell>{product.name}</TableCell>
                    <TableCell>{product.product_family}</TableCell>
                    <TableCell>{product.description}</TableCell>
                    <TableCell> {quantities[product.id]} </TableCell>
                    <TableCell>{product.currency}{product.list_price}</TableCell>
                    <TableCell>{portings[product.id]}</TableCell>
                    <TableCell>
                      <Typography
                        component="span"
                        sx={{
                          color: '#00AEEF',
                          fontWeight: 'bold',
                        }}
                      >
                        {product.currency}{((parseInt(quantities[product.id], 10) || 0) * product.list_price).toFixed(2)}
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

      {/* Table */}
      <TableContainer component={Paper} sx={{ my: 4 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography fontWeight="bold">{t('ProductFamily')}</Typography>
              </TableCell>
              <TableCell align="right">
                <Typography fontWeight="bold">{t('Subtotal')}</Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedGroupedProducts.map((row, index) => (
              <TableRow key={index}>
                <TableCell>{row.productFamily}</TableCell>
                <TableCell align="right">
                  {row.subtotal.toFixed(2)}
                </TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell colSpan={2}>
                <hr />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography>{t("UntaxedAmount")}</Typography>
              </TableCell>
              <TableCell align="right">
                {untaxedAmount.toFixed(2)}
              </TableCell>
            </TableRow>
            {/* <TableRow>
              <TableCell>
                <Typography>Taxes (10%)</Typography>
              </TableCell>
              <TableCell align="right">
                {taxes.toFixed(2)}
              </TableCell>
            </TableRow> */}
            <TableRow>
              <TableCell>
                <Typography variant="h6" fontWeight="bold">
                  {t("Total")}
                </Typography>
              </TableCell>
              <TableCell align="right">
                <Typography variant="h6" fontWeight="bold">
                  {/* {total.toFixed(2)} */}
                  {untaxedAmount.toFixed(2)}
                </Typography>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      {/* Back and Confirm Buttons */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
        <Button variant="text" sx={{ color: '#00AEEF' }} onClick={handleBack}>
          {t('Back')}
        </Button>
        <Box>
          <Button
            variant="contained"
            sx={{ backgroundColor: '#00AEEF', color: 'white' }}
            onClick={() => handleSubmit(false)}
          >
            {('Save')}
          </Button>
          <Button
            variant="contained"
            sx={{ backgroundColor: '#00AEEF', color: 'white', margin: 1 }}
            onClick={() => handleSubmit(true)}
          >
            {("Create")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ReviewTheSalesOrder;
